import capitalizeFilterLabel from "../utils/capitalizeFilterLabel";

export const FORM_SORT_OPTIONS = [
  { value: "form_name", label: "Form" },
  { value: "form_state", label: "State" },
  { value: "submit_date", label: "Submit Date" },
];

export const FORM_STATE_FILTER_OPTIONS = [
  { value: "all", label: "All States" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "pending", label: "Pending" },
  { value: "deleted", label: "Deleted" },
];

export function buildPersonnelFormsFilterChips({ stateFilter = "all", showDeleted }) {
  const chips = [];
  if (stateFilter && stateFilter !== "all") {
    const label =
      FORM_STATE_FILTER_OPTIONS.find((o) => o.value === stateFilter)?.label ||
      capitalizeFilterLabel(stateFilter);
    chips.push({
      id: "state",
      key: "stateFilter",
      fieldId: "forms-state",
      label: `State: ${label}`,
    });
  }
  if (showDeleted) {
    chips.push({
      id: "deleted",
      key: "showDeleted",
      fieldId: "forms-show-deleted",
      label: "Show Deleted",
    });
  }
  return chips;
}

export function countPersonnelFormsActiveFilters({ stateFilter, showDeleted }) {
  let n = 0;
  if (stateFilter && stateFilter !== "all") n += 1;
  if (showDeleted) n += 1;
  return n;
}
